//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../no/TaggedObject.js";
import "../no/ScCollector.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CameraAxis",1,"Axis",0],[0,"CameraCsys",1,"CoordinateSystem",0],[1,"CameraFace",0,"ScCollector",0],[1,"CameraFacetBodies",0,"SelectNXObjectList",0],[0,"CameraType",1,0],[0,"FaceReverse",1,0],[0,"FovReverse",1,0],[1,"FovSheetBody",0,"ScCollector",0],[1,"HorizontalLength",0,"Expression",0],[1,"HorizontalViewAngle",0,"Expression",0],[1,"InitialRadius",0,"Expression",0],[0,"UseCamera",1,0],[1,"VerticalLength",0,"Expression",0],[1,"VerticalViewAngle",0,"Expression",0],[1,"ViewAngle",0,"Expression",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.VehicleDesign.CloseRangeCameraListItemBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.CloseRangeCameraListItemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.CloseRangeCameraListItemBuilder.Types = Object.freeze({
    "Round" : "Round", "Rectangle" : "Rectangle", "Face" : "Face", "Fov" : "Fov"});

export default SPLM;